InformeViewDirective.$inject = [];

export default function InformeViewDirective() {
    return {
        restrict: 'E',
        scope: {
            'json': '=',
            'informeId': '@',
            'modoImpresion': '@'
        },
        template: require('./informe-view.html'),
        controller: 'InformeViewCtrl as vm',
        bindToController: true
    }
}